import React, { useMemo, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import css from './GroupTagsDropdown.module.scss';
import { popUpTransitionClasses } from '../../../../../styles/transitionStyles/transitionStyles';
import CreateTagIcon from '../../../../../image/create-tag.svg';
import { GroupTagsSearchBar } from './searchGroupTagsBar';
import {
	TagsScrollSearchList,
} from '../../../../../widgets/templates/private-template-tag-group-panel/ui/dropdown/list/TagsScrollSearchList';
import { useCreateTemplateTag } from './services/create-tag/useCreateTemplateTag';
import SaveNewTagButton from './saveButton/SaveNewTagButton';
import { notificationError } from '../../../../Notifications/callNotifcation';
import useCatchEnterClick from '../../../../../hooks/useCatchEnterClick';
import { privateTemplateTagAPI } from '../../../../../entities/template/private-template-tag';

interface GroupTagsDropdownProps {
	groupID: string | undefined,
    onAddChoicedItem: (value: string) => void,
	onRemoveChoicedItem: (value: string) => void,
    selectedItems: string[],
}

export const GroupTagsDropdown = React.forwardRef<HTMLDivElement, GroupTagsDropdownProps>(({
	groupID,
	onAddChoicedItem,
	onRemoveChoicedItem,
	selectedItems,
}, ref) => {
	const [tagName, setTagName] = useState('');
	const [search, setSearch] = useState('');
	const [localSelectedTags, setLocalSelectedTags] = useState<string[]>(selectedItems);

	const {
		data: tagsWithoutGroupsData,
		refetch: refetchTagsWithoutGroups,
	} = privateTemplateTagAPI.useGetTagsWithoutGroupsQuery({
		limit: 127,
		page: 1,
	});

	const onSelectTag = (tagId: number) => {
		if (!localSelectedTags.includes(tagId.toString())) {
			setLocalSelectedTags((prev) => [...prev, tagId.toString()]);
		} else {
			setLocalSelectedTags((prev) => prev.filter((id) => id !== tagId.toString()));
		}
	};

	const onTagNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setTagName(event.target.value);
	};

	const { onCreateTag } = useCreateTemplateTag();

	const createTag = async (name: string) => {
		if (name.length >= 2) {
			try {
				await onCreateTag(name);
				setTagName('');
				refetchTagsWithoutGroups();
			} catch (error) {
				notificationError('Ошибка при создании тега');
			}
		} else {
			notificationError('Тег должен содержать не менее 2-х символов');
		}
	};

	const handleCreateTag = async () => {
		if (tagName.length >= 2) {
			await createTag(tagName);
		} else {
			notificationError('Тег должен содержать не менее 2-х символов');
		}
	};

	useCatchEnterClick(handleCreateTag, tagName.length >= 2);

	const filteredTags = useMemo(() => {
		if (!tagsWithoutGroupsData || !tagsWithoutGroupsData.templateTags) {
			return [];
		}
		return tagsWithoutGroupsData.templateTags.filter(
			tag => tag.name.toLowerCase().startsWith(search.toLowerCase()),
		);
	}, [tagsWithoutGroupsData, search]);

	return (
		<CSSTransition
			timeout={200}
			unmountOnExit
			nodeRef={ref}
			in={!!groupID}
			classNames={popUpTransitionClasses}
		>
			<div className={css.wrapper} ref={ref}>
				<GroupTagsSearchBar
					search={search}
					setSearch={setSearch}
					createTag={createTag}
				/>
				<TagsScrollSearchList
					search={search}
					setSearch={setSearch}
					tags={filteredTags}
					onSelectTag={onSelectTag}
					currentIds={selectedItems.map(Number)}
					onCreateTag={createTag}
					onAddChoicedItem={onAddChoicedItem}
					onRemoveChoicedItem={onRemoveChoicedItem}
					isControlsHidden
				/>
				<div className={css.create_tag}>
					<div className={css.create_tag_icon}>
						<CreateTagIcon />
					</div>
					<input
						placeholder="Создать тег"
						className={css.input}
						value={tagName}
						onChange={onTagNameChange}
					/>
					{
						tagName.length >= 2 && (
							<SaveNewTagButton
								onClick={handleCreateTag}
								text="Сохранить"
							/>
						)
					}
				</div>
			</div>
		</CSSTransition>
	);
});
